/* template */
<template><div :class="({ 'is-browser': isBrowser, 'is-dy': isDyProgramH5() })" :style="(pageStyle)" class="page-personal"><title-bar bg-color="rgba(255, 255, 255, 0)" icon-color="#ffffff" title-color="#ffffff" :title="($t('personal.orderRecords'))" :is-show-right-set="(false)" :isHideNav="(isHideNav)" @backClick="onBackClick" class="page-title-bar"/><div class="page-content"><user-change v-if="(showUserChange)"/><personal-tab :class="({          'is-dy-tab': isDyProgramH5(),          'has-flag': personalApollo.show_flag        })" :tabs="(tabs)" :active="(activeTabKey)" :tabStyle="(partionConf && partionConf.purchaseHistoryTabStyle)" @tab-change="onTabChange" class="page-tab-bar"/><div class="orders"><mpx-view @tap="goLargePromotion" class="large-promotion-flag" v-if="(personalApollo.show_flag)"><mpx-rich-text :nodes="(tips)"></mpx-rich-text></mpx-view><template v-if="(activeTabKey === 'effecting')"><template v-for="(item, index) in (orders)"><component :is="(tabGoodCard)" :key="item['{{ item.id }}']" :order-id="(item.id)" :goods-id="(item.goods_id)" :goods-name="(item.goods_name)" :packages="(item.package)" :currentTime="(item.current_time * 1000)" :expireTime="(item.disable_time * 1000)" :price="(item.pay_amount)" :currency="(item.currency)" :order-time="(item.create_time)" :product-type="(item.product_type)" :card-show="(item.card_show)" @good-click="goOrderDetail(item)"/><div ref="sentinel" class="sentinel" v-if="(orders.length > 2 ? index === orders.length - 2 : index === 0)"></div></template><loading v-if="(isLoadingNextPage)"/><finish v-if="(finish && orders.length)"/><empty v-if="(!isLoadingNextPage && finish && !orders.length)"/></template><div class="goods-container" v-else><template v-for="(item, index) in (orders)"><component :is="(tabGoodCard)" :key="item['{{ item.id }}']" :good-info="(item)" :lang="(GlobalEnv.lang)" is-order shadow :showRechargePhone="(partionConf && partionConf.purchaseHistoryListPhoneFlag)" :showGoodsUsage="(partionConf && partionConf.goodsUsageFlag)" @good-click="goOrderDetail(item)" @subtarClick="subtarClick(item, $event)" class="good-card-item"/><div ref="sentinel" class="sentinel" v-if="(orders.length > 3 ? index === orders.length - 3 : index === 0)"></div></template><loading v-if="(isLoadingNextPage)"/><finish v-if="(finish && orders.length)"/><empty v-if="(!isLoadingNextPage && finish && !orders.length)"/></div></div></div></div></template>

/* styles */
<style lang="stylus" scoped mpxStyleOptions='{"mid":"mc5106ea0"}'>
.page-personal
  width 100vw
  height 100vh
  // background-image url('https://ut-static.udache.com/webx/fe-agility-wyc/oxbIHGiFUtM5acxNxQMgC.png')
  background-size 100%
  background-repeat no-repeat
  background-position 0 0
  display flex
  flex-flow column nowrap
  justify-content flex-start
  align-items stretch
  &.is-browser
    background-position-y -90rpx
  &.is-dy
    background-color: #F9F9F9
.page-title-bar
  flex none
.page-content
  flex auto
  display flex
  flex-flow column nowrap
  justify-content flex-start
  align-items stretch
  position relative
  overflow-y hidden
  .page-tab-bar
    flex none
    &.is-dy-tab
      box-shadow 0rpx 5rpx 13rpx 0rpx rgba(213,213,213,0.3)
      margin-top 15rpx
      &.has-flag
        margin-top 0 // 抖音大促
        margin-bottom 9rpx
        padding-top 4rpx
        box-shadow 0rpx 1rpx 5rpx 0 rgba(0,0,0,0.16)
  .orders
    flex auto
    overflow-y scroll
    padding-bottom: constant(safe-area-inset-bottom)
    padding-bottom: env(safe-area-inset-bottom)
    .large-promotion-flag // 抖音大促
      width 100%
      // height 45rpx
      line-height 45rpx
      margin-bottom 18rpx
      background-color #FFF5CB
      text-align center
      font-family PingFang SC-Medium, PingFang SC
      font-size 19rpx
      font-weight 500
      color #FF0000
    .click-me
      text-decoration underline
.goods-container
  margin 0 auto
  display flex
  flex-flow column nowrap
  justify-content flex-start
  align-items center
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "../../../node_modules/@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentSrcMode = "wx"

import mpx, { createPage } from '@mpxjs/core'
import { is, query, hashQuery, goTo, utils, bridge, xenv } from '@didi/webx-js'
import { GlobalEnv, setPageShareConfig, setTitle, URLQueries } from '../../lib/webx'
import { request, Errno } from '../../lib/webx/api'
import { GlobalConfig } from '../../lib/webx/config'
import { initEnv, login } from '../../lib/webx/global_env'
import { getParamsPartitionIdByXenv, getPartitionId } from '../../lib/webx/global_env/partition_id'
import { getUrlBizExtraParams } from '../../lib/webx/global_env/url_query'
import { EnumGoodsDetailIsSpike, EnumGoodsType, EnumPartitionID } from '../../lib/webx/defines'
import { TrackMap } from '../../lib/webx/common_methods/track_map'
import { getErrorMessage } from '../../lib/webx/utils/error'
import { navigateToWebx } from '../../lib/js/navigateTo'
import { isDyProgramH5 } from '../../lib/js/env.js'
import { MASErrorTrackLoadOrderListError } from '../../lib/webx/mas_error_track'
import { PROD_CONFIG, PURCHASE_HISTORY_TABS } from '../../lib/webx/config/prod_config'
import { getGoodsTip } from '../../lib/webx/utils/ui'
import { clickGoodsGuideMpAppHome, getMpAppHomeXenvInfo } from '../../lib/webx/utils/guide_app_home'
import { getProdConfFromApollo, getformateLangMessage } from '../../lib/webx/global_env/get_prod_config'
import { getQueryIdsByKeys } from '../../lib/webx/utils/get_query_ids'
import { hideNativeBar } from '../../lib/js/util'
import { restoreTokenToUrl } from '../../lib/js/token-guard'

const FIXED_PAGE_SIZE = 4 // 这个数改了也没用，不能改，并且判断有没有下一页要用

createPage({
  async onShow() {
    this.resetTab(hashQuery().active || query().active || this.activeTabKey)
    this.finish = false
    this.showFlag = true
    this.isLoadingNextPage = false
    await initEnv({ needLocation: true,  needLogin: true })
    setTitle(this.$t('personal.orderRecords'))
    if (GlobalEnv.isLogin) {
      mpx.showLoading()
      await this.getOrderList()
      mpx.hideLoading()
    }
    document.getElementById('loading') && (document.getElementById('loading').style.display = 'none')
    this.shareData = setPageShareConfig()
    TrackMap.personal.exposed.call(this, this.activeTabInfo)
  },
  async onLoad() {
    window.PerfTrack?.jsReady?.()
    // console.log('------【onLoad】]', query(), hashQuery(), is('miniprogram'))
    // 购买记录中url存在没有 partitionId的情况， 当没有使用 xenv 获取partition_id兜底
    const partitionId = getPartitionId()
    this.partionConf = PROD_CONFIG[partitionId] || PROD_CONFIG.default
    await initEnv({ needLocation: true, needLogin: true, removeCacheEnv: true, back_url: window.location.href })
    // 清空removeCacheEnv的作用： 订单列表页会单独进行投放，存在没有登录的情况下，进入到onLoad前会先执行到app中的initEnv，此时是非强登录的，导致执行到本条initEnv会取到上次promise，从而没有拉起登录
    if (!GlobalEnv.isLogin) {
      // 没有登录的情况弹出弹窗
      this.showErrModal(this.$t('common.login'), Errno.onLogin)
    }
    this.onPageShow = async evt => {
      if (this.showFlag) {
        return
      }
      if (evt.persisted) {
        this.finish = false
        this.resetTab(this.activeTabKey)
        this.isLoadingNextPage = false
        mpx.showLoading()
        await this.getOrderList()
        mpx.hideLoading()
        this.shareData = setPageShareConfig()
        TrackMap.personal.exposed.call(this, this.activeTabInfo)
      }
    }
    this.showUserChange = !this.isMiniProgram && !this.isPassenger && !this.isEsapp && !is('hwfastapp') && !is('hypassenger')
    window.addEventListener('pageshow', this.onPageShow)
  },
  ready() {
    // 滚动加载
    this.observer = new IntersectionObserver(entries => {
      entries.forEach(async entry => {
        if (
          entry.isIntersecting &&
          (entry.boundingClientRect?.y > entry.rootBounds?.height / 2 || !entry.rootBounds)
        ) {
          if (this.isLoadingNextPage) return
          this.isLoadingNextPage = true
          await this.getOrderList()
          this.isLoadingNextPage = false
        }
      })
    })
  },
  onUnload() {
    window.removeEventListener('pageshow', this.onPageShow)
    this.observer.disconnect()
  },
  data: {
    GlobalEnv,
    activeTabKey: PURCHASE_HISTORY_TABS.effecting.key,
    activeTabInfo: {},
    finish: false,
    isLoadingNextPage: false,
    // 环境类
    isPassenger: is('passenger'),
    isEsapp: is('esapp'),
    isMiniProgram: is('miniprogram'),
    showFlag: false,
    partionConf: {},
    showUserChange: false,
  },
  computed: {
    changeUserShow() {
      return ![ 'passenger', 'hypassenger', 'esapp' ].includes(xenv()) && !this.isMiniProgram
    },
    isBrowser() {
      return ![ 'passenger', 'hypassenger' ].includes(xenv()) && !this.isMiniProgram
    },
    orders() {
      return this.activeTabInfo.data || []
    },
    tabs() {
      return this.partionConf?.purchaseHistoryListTabs || []
    },
    tabGoodCard() {
      return this.partionConf?.component[this.activeTabKey]
    },
    pageStyle() {
      const apoImg = getProdConfFromApollo(null, {
        searchKey: 'order_list.header_img',
      })
      return apoImg ? {
        backgroundImage: `url(${utils.webpUrl(apoImg)})`,
      } : {}
    },
    tips() {
      const tips = getformateLangMessage(this.personalApollo.flag_text)
      const htmlStr = tips
        .replace(/\{/g, '<span class="click-me">')
        .replace(/\}/g, '</span>')
      return htmlStr
    },
    personalApollo() {
      return getProdConfFromApollo(null, {
        apolloData: GlobalEnv.apolloData,
        searchKey: 'order_list',
      }) || {}
    },
    isHideNav() {
      return hideNativeBar()
    },
  },
  methods: {
    isDyProgramH5,
    async reInitPage() {
      this.resetTab(hashQuery().active || this.activeTabKey)
      this.finish = false
      this.showFlag = true
      this.isLoadingNextPage = false
      mpx.showLoading()
      await this.getOrderList()
      mpx.hideLoading()
      this.shareData = setPageShareConfig()
      TrackMap.personal.exposed.call(this, this.activeTabInfo)
    },
    resetTab(tabKey, ckFlag) {
      const tabKeys = this.tabs.map(item => item.key)
      // 纠正url中携带actvie在当前partition下不不存在
      if (tabKeys.indexOf(tabKey) === -1) {
        this.activeTabKey = this.tabs[0].key
      } else {
        this.activeTabKey = tabKey
      }
      this.activeTabInfo = PURCHASE_HISTORY_TABS[this.activeTabKey]
      this.activeTabInfo.page = 1
      this.activeTabInfo.data = []
      if (ckFlag) {
        TrackMap.personal.changeTab(this.activeTabInfo)
      }
    },
    async getOrderList() {
      if (this.finish) return
      try {
        const params = {
          source_id: GlobalEnv.channelId,
          token: GlobalEnv.loginInfo.token,
          page: this.activeTabInfo.page,
          size: FIXED_PAGE_SIZE,
          partition_id: getParamsPartitionIdByXenv(),
          product_type: URLQueries.getQuery('product_type') || '',
        }
        if (this.activeTabInfo.params) {
          Object.assign(params, this.activeTabInfo.params)
        }
        // 处理指定查询ids
        const ids = getQueryIdsByKeys([ 'append_ids', 'ids' ], { needMonitor: true })
        if (ids) {
          params.goods_id = ids
          params.source_channel = GlobalEnv.channelId
        }
        const beforeactiveTabKey = this.activeTabKey
        const beforePage = this.activeTabInfo.page
        const { lists } = await request.get(GlobalConfig.APIs.orderList, params)
        // 不等于的时候，说明切 tab 了，就不要更新数据了。主要是为了修复切 tab 特别快的时候，上一个 tab 的最后一条数据切完了才回来。
        if (beforePage === 1) {
          this.activeTabInfo.data = []
          this.activeTabInfo.page = 1
        }
        if (this.activeTabKey === beforeactiveTabKey) {
          this.activeTabInfo.data.push(...lists)
          this.activeTabInfo.page += 1
          console.log('lists.length===', lists.length, FIXED_PAGE_SIZE)
          if (lists.length < FIXED_PAGE_SIZE) {
            this.finish = true
          } else if (this.activeTabInfo.needPreload && this.activeTabInfo.page < 3) {
            await this.getOrderList()
          }
          this.observeSentinel()
        }
        this.showFlag = false
      } catch (error) {
        this.showFlag = false
        this.finish = true
        // this.showErrModal(getErrorMessage(error), error?.extra?.errno)
        MASErrorTrackLoadOrderListError(getErrorMessage(error, {
          friendly: false,
        }), error)
      }
    },
    showErrModal(content, errno){
      mpx.showModal({
        content,
        success: res => {
          if (res.cancel) {
            return
          }
          this.dealListErr(errno)
        },
      })
    },
    async onTabChange({ detail }) {
      if (!GlobalEnv.isLogin) {
        this.dealListErr(Errno.onLogin)
        return
      }
      if (this.activeTabKey === detail) return
      this.resetTab(detail, true)
      this.finish = false
      mpx.showLoading()
      await this.getOrderList()
      mpx.hideLoading()
    },
    onBackClick() {
      mpx.navigateBack()
      const queries = Object.assign({}, query(), hashQuery())
      const fromPersonalCenter = queries.page_select === 'gulfstream_other_page'
      const isIOS = is('iphone,ipad,ipod')
      if (this.isPassenger && isIOS && this.$router.stack?.length < 2 && fromPersonalCenter) {
        bridge.showNativeBar({}, () => {})
        bridge.updateNaviView({
          navstyle: 0,
        }, () => {})
      }
    },
    observeSentinel() {
      this.$refs.sentinel?.[0] &&
        this.observer.unobserve(this.$refs.sentinel[0])
      this.$nextTick(() => {
        this.$refs.sentinel?.[0] && this.observer.observe(this.$refs.sentinel[0])
      })
    },
    goOrderDetail(goods) {
      const xenvInfo = getMpAppHomeXenvInfo(goods)
      if (xenvInfo && xenvInfo.otherDetailPageJumpAppHome) {
        clickGoodsGuideMpAppHome(xenvInfo, query())
        return
      }
      // 豪华车月卡逻辑，后端 URL 优先级最高
      if (goods.link_url) {
        const sameProduct = goods.link_url.indexOf('quartz-mall') > -1
        const params = {
          ...query(),
          order_id: goods.id,
        }
        if (!sameProduct) {
          delete params.xbiz
          delete params.prod_key
          delete params.xpsid
          delete params.xpsid_from
          delete params.xpsid_share
        }
        if (params.hideNavigation) {
          delete params.hideNavigation
        }
        restoreTokenToUrl()
        goTo({
          url: goods.link_url,
          params,
          extParams: {
            h5JumpMethod: 'openPage',
            sameProduct,
          },
        })
        return
      }
      // 月卡逻辑
      if (URLQueries.getQuery('partition_id') - 0 === EnumPartitionID.MonthlyCard) {
        navigateToWebx({
          pathname: 'help',
          query: {
            id: goods.goods_id,
            channelId: GlobalEnv.channelId,
            goodsType: goods.goods_type,
            partitionId: EnumPartitionID.MonthlyCard,
          },
          openPage: !!GlobalEnv.atDidao,
        })
        return
      }
      // 拼车周卡逻辑
      if (goods.goods_type === EnumGoodsType.Carpool) {
        restoreTokenToUrl()
        goTo({
          url: goods.link_url,
          params: {
            token: GlobalEnv.loginInfo.token,
            source: 'mall',
          },
        })
        return
      }
      const params = {
        ...query(),
        ...hashQuery(),
        channelId: GlobalEnv.channelId,
        from: GlobalEnv.from,
      }
      let pathname = 'orderDetail'
      // 进行中、失败退款中且活动未结束
      // const groupContinue = (goods.group_id !== 0 && goods.status === 7) || (goods.current_time === goods.instance_end_time)
      // const goodsProcessFlag =  groupContinue || goods.group_id && goods.status === 2 && goods.group_flag !== 4
      // 拼团商品 && 拼团未成功 非 old_goods 老拼团商品
      const goodsProcessFlag = goods.is_spike === EnumGoodsDetailIsSpike.Group && goods.group_id !== 0 && goods.group_flag !== 1 && goods.old_goods !== 1
      if (goodsProcessFlag) {
        pathname = 'goodsProcess'
        Object.assign(params, {
          groupId: goods.group_id,
          prev: 'order',
          id: goods.goods_id,
          orderId: goods.id,
        })
      } else {
        Object.assign(params, {
          id: goods.id,
          groupId: goods.group_id,
        })
        window.mallTrackEvent('c_trippackage_history_taocan_detail_ck', '用户点击具体产品进入', {
          pid: GlobalEnv.loginInfo.uid,
          goods_id: goods.goods_id,
          didichn: URLQueries.getQuery('didichn') || '',
        })
      }
      TrackMap.personal.goDetail(goods.goods_id, goods.status)
      delete params.at_didao
      delete params.from_bottombar
      navigateToWebx({
        pathname,
        query: params,
        openPage: !!GlobalEnv.atDidao,
      })
    },
    goLargePromotion(){
      if (!this.personalApollo.flag_link) return
      const adParams = getUrlBizExtraParams()
      restoreTokenToUrl()
      goTo({
        url: this.personalApollo.flag_link,
        params: {
          ...adParams,
          token: GlobalEnv.loginInfo.token,
        },
      })
    },
    subtarClick(goods, e) {
      const { target } = e?.detail || {}
      switch (target) {
        case 'price':
          this.showGoodsUsageToast(goods)
          break
      }
    },
    showGoodsUsageToast(goods) {
      const tips = getGoodsTip(goods, false)
      if (tips && tips.length) {
        mpx.showToast({
          title: tips.join(';'),
          icon: 'none',
        })
      }
    },
    dealListErr(errno) {
      if (errno === Errno.onLogin) {
        login({
          back_url: window.location.href,
          needReload: false,
        }).then(res => {
          this.reInitPage()
        }).catch(() => {
          // this.reInitPage()
        })
      }
    },
  },
})


  const currentOption = global.currentOption
  export default processOption(
    currentOption,
    "page",
    "",
    "",
    {"backgroundColor":"#ffffff"},
    // @ts-ignore
    {},
    // @ts-ignore
    {'error-page':getComponent(require("../../components/common/error-page.mpx?component=true&componentId=error-pagebda7909e")),'personal-tab':getComponent(require("../../components/personal/tab.mpx?component=true&componentId=tab6691b08a")),'good-card-dy':getComponent(require("../../components/dy/good_card.mpx?component=true&componentId=good_card27e1a7cd")),'title-bar':getComponent(require("../../../node_modules/@didi/wyc-components/src/components/title-bar/index.mpx?component=true&componentId=index461bd906")),'user-change':getComponent(require("../../components/personal/user_change.mpx?component=true&componentId=user_change2222576c")),'finish':getComponent(require("../../components/personal/finish.mpx?component=true&componentId=finish5561e09b")),'empty':getComponent(require("../../components/personal/empty.mpx?component=true&componentId=empty06ad35b3")),'loading':getComponent(require("../../components/index-v2/goods_list/components/loading.mpx?component=true&componentId=loadingd8a157b0")),'order-effecting-card':getComponent(require("../../components/personal/order_card/index.mpx?component=true&componentId=index23a1b4ec")),'good-card':getComponent(require("../../../node_modules/@didi/trade-sdk/lib/quartz/ui/good_card/index.mpx?component=true&componentId=index4ce63343")),'mpx-view':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?component=true"), { __mpxBuiltIn: true }),'mpx-rich-text':getComponent(require("builtInComponent.vue!=!../../../node_modules/@mpxjs/webpack-plugin/lib/built-in-loader!@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-rich-text.vue?component=true"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
